import React from "react";
import { TYPO, COLORS, RADIUS } from "theme/tokens";

// ──────────────────────────────────────────────────────────────────────────
// MAS 設計系統共用元件：Label（標籤 / 徽章）
//   對齊 design guideline「Labels」：實心橘 / 實心黑 / 外框橘 / 外框灰
//   以及風險分數標籤（高/中/低風險 = 積極/平衡/保守 三色）。
//   全部顏色/字體/圓角引用 theme/tokens（單一來源）。
//
//   用法：
//     <Label>Label</Label>                          // 預設 = 實心橘
//     <Label color="black">Label</Label>            // 實心黑
//     <Label variant="outline">Label</Label>        // 外框橘
//     <Label variant="outline" color="black" />     // 外框灰(黑框)
//     <RiskLabel level="high" score={72} label="高風險" />  // 高風險 72 分
// ──────────────────────────────────────────────────────────────────────────

const HUE = {
  orange: COLORS.main,  // #F36D26
  black: COLORS.black,  // #000000
};

// variant: 'filled' | 'outline'  color: 'orange' | 'black'
export default function Label({
  children,
  variant = "filled",
  color = "orange",
  style,
  ...rest
}) {
  const c = HUE[color] || HUE.orange;
  const filled = variant === "filled";
  return (
    <span
      style={{
        ...TYPO.bodyM,
        fontWeight: 500,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "4px 12px",
        borderRadius: RADIUS.s, // 6
        whiteSpace: "nowrap",
        background: filled ? c : COLORS.white,
        color: filled ? COLORS.white : c,
        border: filled ? "1px solid transparent" : `1px solid ${c}`,
        boxSizing: "border-box",
        ...style,
      }}
      {...rest}
    >
      {children}
    </span>
  );
}

// 風險分數標籤 — level: 'low' | 'medium'/'mid' | 'high'
//   高=積極橘 riskHigh / 中=平衡黃 riskMid / 低=保守 riskLow（design guideline 暖色階）
const RISK = {
  low: { color: COLORS.riskLow, fallback: "低風險" },
  medium: { color: COLORS.riskMid, fallback: "中風險" },
  mid: { color: COLORS.riskMid, fallback: "中風險" },
  high: { color: COLORS.riskHigh, fallback: "高風險" },
};

export function RiskLabel({ level = "medium", score, label, scoreUnit = "分", style, ...rest }) {
  const r = RISK[level] || RISK.medium;
  const text = label || r.fallback;
  return (
    <span
      style={{
        ...TYPO.bodyM,
        fontWeight: 700,
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        height: 28,
        padding: "0 12px",
        borderRadius: RADIUS.s, // 6
        whiteSpace: "nowrap",
        background: r.color,
        color: COLORS.white,
        boxSizing: "border-box",
        ...style,
      }}
      {...rest}
    >
      {text}{score != null ? ` ${score}${scoreUnit ? ` ${scoreUnit}` : ""}` : ""}
    </span>
  );
}
